<template>
  <layout>
    <div class="sm:w-1/2 mx-2 sm:mx-auto  mb-0 mt-4 px-4 py-2 text-left">

      <h2
        class="text-2xl w-full font-light leading-7  text-gray-900 sm:text-2xl sm:leading-9 sm:truncate flex items-center justify-between">

        <div class="flex items-center flex-1">
          <Link :href="route('control-panel.index')">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-5 h-5 hover:text-markencode-blue mr-2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
          </svg>
          </Link>

          <p>Workshops &amp; Umfragen</p>

        </div>


        <div class="flex"><span class="shadow-sm rounded-md">
            <Link :href="route('control-panel.workshops.create')"
              class="inline-flex items-center px-2 py-1 border border-transparent text-sm font-medium rounded-md text-gray-500 bg-gray-300 shadow-sm hover:bg-gray-400 hover:text-white focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="w-5 h-5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            </Link>
          </span></div>
      </h2>
    </div>

    <div class="sm:w-1/2 mx-2 sm:mx-auto px-0 py-5 text-center">

      <table class="table-fixed min-w-full divide-y divide-gray-300 max-w-full">

        <thead class="bg-gray-50">
          <tr>
            <th v-if="false" scope="col" class="w-1/12 py-3.5 pl-1 pr-1">
              <div class="flex"><span class="shadow-sm rounded-md">

                  <button @click="processGroupOrder"
                    class="inline-flex items-center px-2 py-1 border border-transparent text-sm font-medium rounded-md text-gray-500 bg-gray-300 shadow-sm hover:bg-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-default"
                    :class="hasGroupedOrder ? 'cursor-pointer opacity-100' : 'cursor-default opacity-50'">

                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
                      class="w-5 h-5 outline-none text-gray-500  ">
                      >
                      <rect width="256" height="256" fill="none" />
                      <circle cx="128" cy="64" r="32" fill="none" stroke="currentColor" stroke-linecap="round"
                        stroke-linejoin="round" stroke-width="16" />
                      <line x1="128" y1="96" x2="128" y2="176" fill="none" stroke="currentColor" stroke-linecap="round"
                        stroke-linejoin="round" stroke-width="16" />
                      <path
                        d="M168,139.07c37.58,6,64,20.29,64,36.93,0,22.09-46.56,40-104,40S24,198.09,24,176c0-16.64,26.42-30.91,64-36.93"
                        fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="16" />
                    </svg>
                  </button>
                </span>
              </div>

            </th>


            <th scope="col" class="w-5/12 py-3.5 pl-1 pr-1 text-left text-xs font-semibold text-gray-900 sm:pl-3">
              Anlagedatum<br />Teiln. mit
              Antworten / gesamt
            </th>
            <th scope="col" class="px-1 py-3.5 text-left text-sm font-semibold text-gray-900"></th>
          </tr>
        </thead>
        <tbody class="bg-white">

          <tr v-if="!workshops.length">
            <td colspan="2" class="text-sm text-gray-500 text-left px-3 py-2">Es liegen keine Workshops/Umfragen vor.
            </td>
          </tr>


          <tr v-for="(workshop, idx) in allWorkshops" :key="idx" class="even:bg-gray-50">

            <td v-if="false" class="w-1/12 py-4 pl-1 pr-1 align-top">
              <input name="orders[]" type="checkbox" @click="toggleForGroupedOrder(workshop)"
                :disabled="!canBeOrdered(workshop)"
                class="h-4 w-4 rounded border-gray-300 text-markencode-blue focus:ring-markencode-blue"
                :class="canBeOrdered(workshop) ? 'opacity-100' : 'opacity-30'">
            </td>


            <td class="w-5/12 py-4 pl-1 pr-1 text-left text-sm font-medium text-gray-900 sm:pl-3 min-w-0">

              <div class=" flex items-start space-x-2">
                <div>
                  <session-type-icon :session-type="workshop.session_type" class="mt-1"></session-type-icon>
                </div>

                <div>
                  <Link :href="route('control-panel.workshops.setup', { sessionUuid: workshop.uuid })"
                    v-if="canBeEdited(workshop)"
                    class="block hover:text-markencode-blue w-44 md:w-52 lg:w-72 xl:w-80 2xl:w-96 overflow-hidden text-ellipsis">
                  {{ workshop.customer_name }}
                  </Link>

                  <p v-if="!canBeEdited(workshop)"
                    class="w-44 md:w-52 lg:w-72 xl:w-80 2xl:w-96 overflow-hidden text-ellipsis">
                    {{ workshop.customer_name }}
                  </p>

                  <Link :href="route('control-panel.workshops.setup', { sessionUuid: workshop.uuid })"
                    v-if="canBeEdited(workshop) && workshop.project_name"
                    class="block hover:text-markencode-blue w-44 md:w-52 lg:w-72 xl:w-80 2xl:w-96 overflow-hidden text-ellipsis">
                  {{ workshop.project_name }}
                  </Link>

                  <p v-if="!canBeEdited(workshop) && workshop.project_name"
                    class="w-44 md:w-52 lg:w-72 xl:w-80 2xl:w-96 overflow-hidden text-ellipsis">
                    {{ workshop.project_name }}
                  </p>


                  <Link :href="route('control-panel.workshops.setup', { sessionUuid: workshop.uuid })"
                    v-if="canBeEdited(workshop) && workshop.brandname"
                    class="block hover:text-markencode-blue w-44 md:w-52 lg:w-72 xl:w-80 2xl:w-96 overflow-hidden text-ellipsis">
                  {{ workshop.brandname }}
                  </Link>

                  <p v-if="!canBeEdited(workshop) && workshop.brandname"
                    class="w-44 md:w-52 lg:w-72 xl:w-80 2xl:w-96 overflow-hidden text-ellipsis">
                    {{ workshop.brandname }}
                  </p>


                  <div class="flex items-center space-x-1">
                    <p class="text-gray-400">{{ workshop.created_at |
                      formatDate }}</p>


                    <svg v-if="hasHistory(workshop)" v-tooltip.top="{ ref: 'sharedTooltip' }"
                      @mouseenter="activeWorkshop = workshop" xmlns="http://www.w3.org/2000/svg" fill="none"
                      viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-gray-400">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                    </svg>

                    <p class="text-gray-400">|</p>
                    <p class="text-gray-400">{{ workshop.questions_count }} Fragen</p>
                  </div>

                  <p class="text-gray-400">
                    {{ workshop.participants_with_answers_count }} / {{ workshop.participants_count }} Teiln.

                    <span v-if="workshop.pricing.total_price > 0" class="text-gray-400 cursor-help" v-tooltip.top="{
                      content: pricingInfo(workshop.pricing),
                    }">| {{ workshop.pricing.total_price | formatEuroAmount }}</span>
                  </p>

                  <p v-if="workshop.analysis_ordered_at" class="text-gray-400">Bestellt am {{
                    workshop.analysis_ordered_at
                    |
                    formatDate }}</p>

                </div>
              </div>

            </td>

            <td
              class="w-full relative whitespace-nowrap pt-5 pl-1 pr-1 text-sm font-medium sm:pr-3 flex items-center    justify-end space-x-2">


              <survey-status v-if="workshop.session_type == 'diy_workshop'" :survey="workshop"></survey-status>

              <workshop-status v-if="workshop.session_type == 'workshop'" :workshop="workshop"></workshop-status>


              <svg v-if="!canBeEdited(workshop)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor" class="w-5 h-5 text-gray-300 outline-none">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z" />
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z" />
              </svg>

              <Link v-if="canBeEdited(workshop)" :href="introRoute(workshop)">

              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor"
                class="w-5 h-5 text-gray-500  hover:text-markencode-blue outline-none cursor-pointer">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z" />
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z" />
              </svg>

              </Link>



              <svg v-if="canBeOrdered(workshop)" @click="order(workshop)"
                v-tooltip.top="{ content: orderButtonTooltip(workshop), visible: orderButtonTooltip(workshop) !== null }"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" class="w-5 h-5 outline-none"
                :class="workshop.analysis_ordered_at ? 'text-markencode-green' : 'text-gray-500 hover:text-markencode-blue cursor-pointer'">
                >
                <rect width="256" height="256" fill="none" />
                <circle cx="128" cy="64" r="32" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="16" />
                <line x1="128" y1="96" x2="128" y2="176" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="16" />
                <path
                  d="M168,139.07c37.58,6,64,20.29,64,36.93,0,22.09-46.56,40-104,40S24,198.09,24,176c0-16.64,26.42-30.91,64-36.93"
                  fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" />
              </svg>

              <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
                class="w-5 h-5 outline-none text-gray-300">
                >
                <rect width="256" height="256" fill="none" />
                <circle cx="128" cy="64" r="32" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="16" />
                <line x1="128" y1="96" x2="128" y2="176" fill="none" stroke="currentColor" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="16" />
                <path
                  d="M168,139.07c37.58,6,64,20.29,64,36.93,0,22.09-46.56,40-104,40S24,198.09,24,176c0-16.64,26.42-30.91,64-36.93"
                  fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16" />
              </svg>

              <!-- <svg
                v-if="!canBeOrdered(workshop)"
                  v-tooltip.top="{ content: orderButtonTooltip(workshop), visible: orderButtonTooltip(workshop) !== null }"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" class="w-5 h-5 outline-none text-gray-300 cursor-default">
                  >
                  <rect width="256" height="256" fill="none" />
                  <circle cx="128" cy="64" r="32" fill="none" stroke="currentColor" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="16" />
                  <line x1="128" y1="96" x2="128" y2="176" fill="none" stroke="currentColor" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="16" />
                  <path
                    d="M168,139.07c37.58,6,64,20.29,64,36.93,0,22.09-46.56,40-104,40S24,198.09,24,176c0-16.64,26.42-30.91,64-36.93"
                    fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="16" />
                </svg> -->






              <svg v-if="!hasExtraActions(workshop)" class="h-5 w-5 text-gray-300" viewBox="0 0 20 20"
                fill="currentColor" aria-hidden="true">
                <path
                  d="M10 3a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM10 8.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM11.5 15.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z" />
              </svg>

              <div v-if="hasExtraActions(workshop)" class="relative flex-none">
                <button type="button" @click.stop="expandMoreInfoMenu(workshop)"
                  class="-m-2.5 block p-2.5 text-gray-500  hover:text-markencode-blue" id="options-menu-0-button"
                  aria-expanded="false" aria-haspopup="true">
                  <span class="sr-only">Open options</span>
                  <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path
                      d="M10 3a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM10 8.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM11.5 15.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z" />
                  </svg>
                </button>


                <transition enter-active-class="transition ease-out duration-100"
                  enter-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                  leave-active-class="transition ease-in duration-75" leave-class="transform opacity-100 scale-100"
                  leave-to-class="transform opacity-0 scale-95">
                  <div v-if="expandedMoreInfoMenu == workshop.id" v-click-outside="collapseMoreInfoMenu"
                    class="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none divide-y divide-gray-100"
                    role="menu" aria-orientation="vertical" aria-labelledby="options-menu-0-button" tabindex="-1">
                    <!-- Active: "bg-gray-50", Not Active: "" -->






                    <!-- Edit workshop: start -->
                    <Link :href="route('control-panel.workshops.setup', { sessionUuid: workshop.uuid })"
                      v-if="canBeEdited(workshop)"
                      class="px-3 py-1.5 text-sm leading-6 text-gray-900 flex items-center gap-x-2 group hover:text-markencode-blue"
                      role="menuitem" tabindex="-1">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                      stroke="currentColor"
                      class="w-4 h-4 text-gray-400 outline-none shrink-0 group-hover:text-markencode-blue">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
                    </svg>
                    Bearbeiten</Link>
                    <!-- Edit workshop: end -->



                    <!-- Order workshop: start -->
                    <!-- <button v-if="canBeOrdered(workshop)" @click="order(workshop)"
                      class="px-3 py-1.5 text-sm leading-6 text-gray-900 flex items-center gap-x-2 group hover:text-markencode-blue"
                      role="menuitem" tabindex="-1">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
                        class="w-4 h-4 text-gray-400 outline-none shrink-0 group-hover:text-markencode-blue">
                        <rect width="256" height="256" fill="none" />
                        <circle cx="128" cy="64" r="32" fill="none" stroke="currentColor" stroke-linecap="round"
                          stroke-linejoin="round" stroke-width="16" />
                        <line x1="128" y1="96" x2="128" y2="176" fill="none" stroke="currentColor"
                          stroke-linecap="round" stroke-linejoin="round" stroke-width="16" />
                        <path
                          d="M168,139.07c37.58,6,64,20.29,64,36.93,0,22.09-46.56,40-104,40S24,198.09,24,176c0-16.64,26.42-30.91,64-36.93"
                          fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="16" />
                      </svg>
                      Bestellen</button> -->
                    <!-- Order workshop: end -->


                    <!-- Excel download: start -->
                    <div v-if="canDownloadExcel(workshop)" @click="downloadExcel(workshop)"
                      class="px-3 py-1.5 text-sm leading-6 text-gray-900 flex items-center gap-x-2 group hover:text-markencode-blue cursor-pointer"
                      role="menuitem" tabindex="-1">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor"
                        class="w-4 h-4 text-gray-400 outline-none shrink-0 group-hover:text-markencode-blue">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                      </svg>
                      Excel-Download
                    </div>
                    <!-- Excel download: end -->



                    <!-- reset: start -->
                    <div v-if="canBeResetted(workshop)" @click="resetWorkshop(workshop)"
                      class="px-3 py-1.5 text-sm leading-6 text-gray-900 flex items-center gap-x-2 group hover:text-markencode-blue cursor-pointer"
                      role="menuitem" tabindex="-1">

                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor"
                        class="w-4 h-4 text-gray-400 outline-none shrink-0 group-hover:text-markencode-blue">>
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
                      </svg>


                      Zurücksetzen
                    </div>
                    <!-- reset: end -->


                    <!-- delete: start -->
                    <div v-if="canBeRemoved(workshop)" @click="remove(workshop)"
                      class="px-3 py-1.5 text-sm leading-6 text-gray-900 flex items-center gap-x-2 group hover:text-markencode-blue cursor-pointer"
                      role="menuitem" tabindex="-1">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor"
                        class="w-4 h-4 text-gray-400 outline-none shrink-0 group-hover:text-markencode-blue">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                      </svg>
                      Löschen
                    </div>
                    <!-- Delete: end -->
                  </div>

                </transition>
              </div>





            </td>
          </tr>
        </tbody>
      </table>

    </div>

    <confirm-modal v-if="deleteConfirmModal.visible" :headline="deleteConfirmModal.headline"
      :text="deleteConfirmModal.text" @close="deleteConfirmModal.visible = false" @confirm="removeConfirmed"
      class="z-[200]"></confirm-modal>

    <confirm-modal v-if="activateConfirmModal.visible" :headline="activateConfirmModal.headline"
      :text="activateConfirmModal.text" @close="activateConfirmModal.visible = false" @confirm="activateConfirmed"
      class="z-[200]"></confirm-modal>

    <confirm-modal v-if="orderConfirmModal.visible" :headline="orderConfirmModal.headline"
      :text="orderConfirmModal.text" @close="orderConfirmModal.visible = false" @confirm="orderConfirmed"
      class="z-[200]"></confirm-modal>

    <confirm-modal v-if="groupedOrderConfirmModal.visible" :headline="groupedOrderConfirmModal.headline"
      :text="groupedOrderConfirmModal.text" @close="groupedOrderConfirmModal.visible = false"
      @confirm="groupedOrderConfirmed" class="z-[200]"></confirm-modal>



    <div ref="sharedTooltip" class="tooltip-content">
      
      <div v-if="hasActiveWorkshop">
        <p class="text-xs font-semibold">Historie</p>
        <p v-for="log in activeWorkshop?.session_logs" :key="log.id">
          <span v-if="log.action == 'created'" class="text-xs">Angelegt am {{ log.created_at | formatDateTime }}</span>
          <span v-else-if="log.action == 'started'" class="text-xs">Gestartet am {{ log.created_at | formatDateTime }}</span>
          <span v-else-if="log.action == 'stopped'" class="text-xs">Gestoppt am {{ log.created_at | formatDateTime }}</span>
          <span v-else-if="log.action == 'ended_testmode'" class="text-xs">Testphase beendet am {{ log.created_at | formatDateTime }}</span>
          <span v-else-if="log.action == 'resetted'" class="text-xs">Zurückgesetzt am {{ log.created_at | formatDateTime }}</span>
        </p>
      </div>
    </div>


  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout.vue';
import ConfirmModal from '@/Shared/ConfirmModal.vue';
import SurveyStatus from '@/Pages/ControlPanel/Workshops/Shared/SurveyStatus.vue';
import WorkshopStatus from '@/Pages/ControlPanel/Workshops/Shared/WorkshopStatus.vue';
import SessionTypeIcon from '@/Pages/ControlPanel/Shared/SessionTypeIcon.vue';
import ClickOutside from 'vue-click-outside';

export default {
  directives: {
    ClickOutside,
  },

  components: {
    Layout,
    ConfirmModal,
    SurveyStatus,
    WorkshopStatus,
    SessionTypeIcon,
  },

  props: ['workshops', 'translations'],

  data() {
    return {
      allWorkshops: this.workshops,

      activeWorkshop: null,

      expandedMoreInfoMenu: null,

      workshopsInGroupedOrder: [],

      deleteConfirmModal: {
        visible: false,
        itemId: null,
        headline: 'Workshop/Umfrage löschen',
        text: '',
      },

      activateConfirmModal: {
        visible: false,
        itemId: null,
        headline: 'Workshop/Umfrage aktivieren',
        text: '',
      },

      orderConfirmModal: {
        visible: false,
        itemId: null,
        headline: 'Auswertung bestellen',
        text: '',
      },

      groupedOrderConfirmModal: {
        visible: false,
        itemId: null,
        headline: 'Sammel-Auswertung bestellen',
        text: '',
      },

      loading: true,
    };
  },

  methods: {
    expandMoreInfoMenu(workshop) {
      this.expandedMoreInfoMenu = this.expandedMoreInfoMenu == workshop.id ? null : workshop.id;
    },

    collapseMoreInfoMenu() {
      if (this.expandedMoreInfoMenu) {
        this.expandedMoreInfoMenu = null;
      }
    },

    canBeEdited(workshop) {
      return workshop.can_be_edited && workshop.analysis_ordered_at === null;
    },

    canBeRemoved(workshop) {
      return workshop.analysis_ordered_at === null && (this.$page.props.auth.user.id == workshop.author_id || !workshop.author_id);
    },

    canBeOrdered(workshop) {
      return workshop.analysis_ordered_at === null && !workshop.testmode && workshop.pricing?.total_price > 0;
      // && workshop.answers.length > 0
      // && workshop.can_be_activated;
    },

    canBeResetted(workshop) {
      return workshop.session_type == 'workshop' && workshop.analysis_ordered_at === null && workshop.testmode;
    },

    hasExtraActions(workshop) {
      return this.canBeEdited(workshop) || this.canBeRemoved(workshop) || this.canDownloadExcel(workshop) || this.canBeOrdered(workshop) || this.canBeResetted(workshop);
    },

    canDownloadExcel(workshop) {
      if (!workshop.phases) {
        return false;
      }

      return true;
    },

    hasHistory(workshop) {
      if (!this.$page.props.auth.user.is.admin) {
        return false;
      }

      if (!workshop?.session_logs?.length) {
        return false;
      }

      const createdLog = workshop.session_logs.find(log => log.action == 'created');
      if (!createdLog) {
        return false;
      }

      return true;

    },


    historyTooltip(workshop) {
      return `fjhfhjghjf<br />fdg<b>fd</b>fdgh`;
    },

    downloadExcel(workshop) {
      this.expandedMoreInfoMenu = null;
      // console.log(this.route('control-panel.diy-workshops.excel.download', { sessionUuid: workshop.uuid }));
      window.location.href = this.route('control-panel.workshops.excel.download', { sessionUuid: workshop.uuid });
    },

    introRoute(workshop) {
      if (workshop.session_type == 'diy_workshop') {
        return this.route('control-panel.diy-workshops.intro', { sessionUuid: workshop.uuid });
      }

      if (workshop.session_type == 'workshop') {
        return this.route('control-panel.intro', { sessionUuid: workshop.uuid });
      }

      return '';

    },


    toggleForGroupedOrder(workshop) {
      if (this.workshopsInGroupedOrder.includes(workshop)) {
        this.workshopsInGroupedOrder = this.workshopsInGroupedOrder.filter(w => w !== workshop);
      } else {
        this.workshopsInGroupedOrder.push(workshop);
      }
    },


    processGroupOrder() {
      if (!this.hasGroupedOrder) {
        return;
      }

      this.groupedOrderConfirmModal.itemId = null;
      this.groupedOrderConfirmModal.text = `Soll diese Sammelbestellung wirklich ausgeführt werden?`;
      this.groupedOrderConfirmModal.visible = true;
    },


    groupedOrderConfirmed() {
      this.groupedOrderConfirmModal.visible = false;

      this.$inertia.post(
        this.route('control-panel.workshops.order-grouped-analysis'),
        {
          workshopUuids: this.workshopsInGroupedOrder.map(w => w.uuid),
        },
        {
          preserveScroll: true,
          preserveState: false,
        }
      );
    },



    activate(workshop) {
      this.activateConfirmModal.itemId = workshop.uuid;

      let name = '';
      if (workshop.project_name) {
        name = workshop.project_name;
      } else if (workshop.customer_name) {
        name = workshop.customer_name;
      }

      let text = ``;

      if (workshop.session_type == 'workshop') {
        text = `Soll der Workshop <strong>${name}</strong> wirklich aktiviert werden?`;
      }

      if (workshop.session_type == 'diy_workshop') {
        text = `Soll die Umfrage <strong>${name}</strong> wirklich aktiviert werden?`;
      }


      this.activateConfirmModal.text = text;
      // Nach Aktivierung sind keine Änderungen mehr möglich.
      this.activateConfirmModal.visible = true;
    },

    activateConfirmed() {
      if (!this.activateConfirmModal.itemId) return;

      this.activateConfirmModal.visible = false;

      this.$inertia.post(
        this.route('control-panel.workshops.activate', this.activateConfirmModal.itemId),
        {},
        {
          preserveScroll: true,
          preserveState: false,
        }
      );
    },


    order(workshop) {

      if (workshop.analysis_ordered_at) {
        return;
      }

      // console.log(workshop); return;

      let name = '';
      if (workshop.project_name) {
        name = workshop.project_name;
      } else if (workshop.customer_name) {
        name = workshop.customer_name;
      }

      let text = ``;

      if (workshop.session_type == 'workshop') {
        text = `Soll der Workshop <strong>${name}</strong> wirklich bestellt werden?`;
      }

      if (workshop.session_type == 'diy_workshop') {
        text = `Soll die Umfrage <strong>${name}</strong> wirklich bestellt werden?`;
      }

      text += `<p class="my-2">Kosten: <strong>${this.$options.filters.formatEuroAmount(workshop.pricing.total_price)}</strong></p>`;

      this.orderConfirmModal.itemId = workshop.uuid;
      this.orderConfirmModal.text = `${text} Nach Aufgabe einer Bestellung sind keine Änderungen mehr möglich.`;
      this.orderConfirmModal.visible = true;
    },

    orderConfirmed() {
      if (!this.orderConfirmModal.itemId) return;

      this.orderConfirmModal.visible = false;

      this.$inertia.post(
        this.route('control-panel.workshops.order-analysis', this.orderConfirmModal.itemId),
        {},
        {
          preserveScroll: true,
          preserveState: false,
        }
      );
    },


    toggleWorkshop(workshop) {

      this.$inertia.post(this.route('control-panel.workshops.toggle', { sessionUuid: workshop.uuid, }), {}, {
        preserveScroll: true,
        preserveState: false,
      });
    },

    remove(workshop) {
      this.expandedMoreInfoMenu = null;

      let name = '';
      if (workshop.project_name) {
        name = workshop.project_name;
      } else if (workshop.customer_name) {
        name = workshop.customer_name;
      }

      let text = ``;

      if (workshop.session_type == 'workshop') {
        text = `Soll der Workshop <strong>${name}</strong> wirklich gelöscht werden?`;
      }

      if (workshop.session_type == 'diy_workshop') {
        text = `Soll die Umfrage <strong>${name}</strong> wirklich gelöscht werden?`;
      }

      this.deleteConfirmModal.itemId = workshop.uuid;
      this.deleteConfirmModal.text = text;
      this.deleteConfirmModal.visible = true;
    },

    removeConfirmed() {
      if (!this.deleteConfirmModal.itemId) return;

      this.deleteConfirmModal.visible = false;

      this.$inertia.delete(
        this.route('control-panel.workshops.delete', this.deleteConfirmModal.itemId),
        {
          preserveScroll: true,
          preserveState: false,

        }
      );

    },


    resetWorkshop(workshop) {
      this.$inertia.post(
        this.route('control-panel.workshops.reset-test-workshop', { sessionUuid: workshop.uuid, }),
        {},
        {
          preserveScroll: true,
          preserveState: false,
        }
      );
    },

    orderButtonTooltip(workshop) {
      // if (!workshop?.can_be_activated) {
      //   return `Eine Bestellung ist nicht möglich, da für ${workshop.session_type == 'diy_workshop' ? 'diese Umfrage' : 'diesen Workshop'} nicht alle Pflichtangaben gepflegt sind.`;
      // }

      if (workshop?.analysis_ordered_at) {
        return `Bestellt am ${this.$options.filters.formatDate(workshop.analysis_ordered_at)}.`;
      }

      return null;
    },


    pricingInfo(pricing) {
      return `Basispreis ${this.$options.filters.formatEuroAmount(pricing.base_price)} + ${pricing.num_text_questions} Textfragen x ${this.$options.filters.formatEuroAmount(7.5)} = ${this.$options.filters.formatEuroAmount(pricing.total_price_text_questions)} + ${pricing.num_keyword_questions} Schlagwortfragen x ${this.$options.filters.formatEuroAmount(1)} = ${this.$options.filters.formatEuroAmount(pricing.total_price_keyword_questions)} 
      = ${this.$options.filters.formatEuroAmount(pricing.total_price)} Gesamt`;
    },
  },

  computed: {
    hasGroupedOrder() {
      return this.workshopsInGroupedOrder.length > 0;
    },

    hasActiveWorkshop() {
      return this.activeWorkshop !== null;

      // activeWorkshop && activeWorkshop?.session_logs && activeWorkshop?.session_logs?.length > 0
    },
  },
}
</script>
